<div class="container" [ngClass]="{'container__zoom': zoomPageMatValue > 1.25}">
  <div class='ruler-top' [style.width]="reportPage.paperWidth" *ngIf="designService.checkedRuler">
    <div class='cm' *ngFor= "let res of cmRuler">
    <div class='mm' *ngFor= "let res of mmRuler"></div>
    </div>
    <div class="cm"></div>
  </div>
  <div [attr.id]="reportPage.getAnchorId()" (click)="onClick($event)" #pageScreen [ngClass]="{
    'report-page': true,
    'selectable': reportPage.isSelectable,
    'selected': reportPage.isSelected,
    'edited': !reportPage.isSaved(),
    'delete-page-outline': designService.clickedPageIdForDelete == pageKey
  }" [style.width]="reportPage.paperWidth" [style.height]="reportPage.paperHeight"
     [style.paddingTop]="reportPage.paddingTop" [style.paddingBottom]="reportPage.paddingBottom"
     [style.paddingLeft]="reportPage.paddingLeft" [style.paddingRight]="reportPage.paddingRight" [style.fontFamily]="fontFamily" [style.zoom]="zoomPageMatValue" >
  <section *ngIf="reportPage.hasHeader" [ngClass]="{
      'header': true,
      'mark-header-footer': true
    }" [style.height]="reportPage.headerHeight" (dragover)="onDragOver($event, 'Header')"
           (drop)="onDrop($event, 'Header')">
    <canvas *ngIf="reportPage.isDrawMode" [ngClass]="{ 'ghost-layer' : true }" [attr.width]="getCanvasWidth()"
            [attr.height]="getCanvasHeight('Header')" (mousedown)="onBeginDraw($event)"
            (mouseup)="onEndDraw($event, 'Header')"></canvas>

    <div [ngClass]="{'preview-layer' : true}">
      <app-report-text-container class="component-outer" *ngFor="let textKey of headerTextKeys" [pageKey]="pageKey"
                                 [textKey]="textKey" [elementLocation] ="'Header'">
      </app-report-text-container>
      <app-report-line-container class="component-outer" *ngFor="let lineKey of headerLineKeys" [pageKey]="pageKey"
                                 [lineKey]="lineKey" [elementLocation] ="'Header'">
      </app-report-line-container>
      <app-report-image-container class="component-outer" *ngFor="let imageKey of headerImageKeys" [pageKey]="pageKey"
                                  [imageKey]="imageKey" [elementLocation] ="'Header'">
      </app-report-image-container>
      <app-report-rectangle-container class="component-outer" *ngFor="let rectangleKey of headerRectangleKeys"
                                      [pageKey]="pageKey" [rectangleKey]="rectangleKey" [elementLocation] ="'Header'">
      </app-report-rectangle-container>
      <app-report-summary-container class="component-outer" *ngFor="let summaryKey of headerSummaryKeys"
                                    [pageKey]="pageKey" [summaryKey]="summaryKey" [elementLocation] ="'Header'">
      </app-report-summary-container>
      <app-report-picture-container class="component-outer" *ngFor="let pictureKey of headerPictureKeys"
                                    [pageKey]="pageKey" [pictureKey]="pictureKey" [elementLocation] ="'Header'">
      </app-report-picture-container>
      <app-report-signature class="component-outer" *ngFor="let signatureKey of headerSignatureKeys"
                            [pageKey]="pageKey" [signatureKey]="signatureKey" [elementLocation] ="'Header'">
      </app-report-signature>
      <app-report-table class="component-outer" *ngFor="let tableKey of headerTableKeys"
                            [pageKey]="pageKey" [tableKey]="tableKey" [elementLocation] ="'Header'">
      </app-report-table>
    </div>

  </section>

  <section [ngClass]="{
      'body': true,
      'mark-body': true
    }" [style.height]="reportPage.bodyHeight" (dragover)="onDragOver($event, 'Body')" (drop)="onDrop($event, 'Body')">
    <div class='ruler' [style.height]="reportPage.paperWidth" [style.marginLeft]="sideRulerLeftMargin" [style.marginTop]="sideRulerTopMargin" *ngIf="designService.checkedRuler">
      <div class='cm' *ngFor= "let res of cmSideRuler">
        <div class='mm' *ngFor= "let res of mmRuler"></div>
        </div>
      <div class='cm'>
      </div>
     </div>
    <canvas *ngIf="reportPage.isDrawMode" [ngClass]="{'ghost-layer' : true}" [attr.width]="getCanvasWidth()"
            [attr.height]="getCanvasHeight('Body')" (mousedown)="onBeginDraw($event)"
            (mouseup)="onEndDraw($event, 'Body')"></canvas>

    <div [ngClass]="{'preview-layer' : true}">
      <app-report-section class="component-outer" *ngFor="let sectionKey of sectionKeys" [pageKey]="pageKey"
                          [sectionKey]="sectionKey" [elementLocation]="'Body'"></app-report-section>
      <app-report-text-container class="component-outer" *ngFor="let textKey of bodyTextKeys" [pageKey]="pageKey"
                                 [textKey]="textKey" [elementLocation]="'Body'" [drawCustomElement]="designService.customElementAdd">
      </app-report-text-container>
      <app-report-line-container class="component-outer" *ngFor="let lineKey of bodyLineKeys" [pageKey]="pageKey"
                                 [lineKey]="lineKey" [elementLocation]="'Body'">
      </app-report-line-container>
      <app-report-image-container class="component-outer" *ngFor="let imageKey of bodyImageKeys" [pageKey]="pageKey"
                                  [imageKey]="imageKey" [elementLocation]="'Body'">
      </app-report-image-container>
      <app-report-rectangle-container class="component-outer" *ngFor="let rectangleKey of bodyRectangleKeys"
                                      [pageKey]="pageKey" [rectangleKey]="rectangleKey" [elementLocation]="'Body'">
      </app-report-rectangle-container>
      <app-report-summary-container class="component-outer" *ngFor="let summaryKey of bodySummaryKeys"
                                    [pageKey]="pageKey" [summaryKey]="summaryKey" [elementLocation]="'Body'">
      </app-report-summary-container>

      <app-report-subtotal-container class="component-outer" *ngFor="let subTotalKey of bodySubTotalKeys"
                                    [pageKey]="pageKey" [subTotalKey]="subTotalKey" [elementLocation]="'Body'">
      </app-report-subtotal-container>
      <app-report-picture-container class="component-outer" *ngFor="let pictureKey of bodyPictureKeys"
                                    [pageKey]="pageKey" [pictureKey]="pictureKey" [elementLocation]="'Body'">
      </app-report-picture-container>
      <app-report-dataplate-container class="component-outer" *ngFor="let dataPlateKey of bodyDataPlateKeys"
                                      [pageKey]="pageKey" [dataPlateKey]="dataPlateKey" [elementLocation]="'Body'">
      </app-report-dataplate-container>
      <app-report-measurement-points class="component-outer" *ngFor="let measurementPointKey of bodyMeasurementPointKey"
                                     [pageKey]="pageKey" [measurementPointKey]="measurementPointKey" [elementLocation]="'Body'"></app-report-measurement-points>
      <app-visual-events class="component-outer" *ngFor="let visualEventsKey of bodyVisualEventsKeys"
                         [pageKey]="pageKey" [visualEventsKey]="visualEventsKey" [elementLocation]="'Body'"></app-visual-events>
      <app-report-signature class="component-outer" *ngFor="let signatureKey of bodySignatureKeys"
                            [pageKey]="pageKey" [signatureKey]="signatureKey" [elementLocation]="'Body'">
      </app-report-signature>
      <app-report-table class="component-outer" *ngFor="let tableKey of bodyTableKeys"
                        [pageKey]="pageKey" [tableKey]="tableKey" [elementLocation]="'Body'">
      </app-report-table>
      <app-report-iso class="component-outer" *ngFor="let isoKey of bodyInteractiveIsoKeys"
                      [pageKey]="pageKey" [isoKey]="isoKey" [elementLocation]="'Body'">
      </app-report-iso>
      <app-report-dropdown-list class="component-outer" *ngFor="let dropDownListKey of bodyDropDownListKeys"
                                [pageKey]="pageKey" [dropDownListKey]="dropDownListKey" [elementLocation]="'Body'">
      </app-report-dropdown-list>
      <app-report-custom-element *ngFor="let customElementKey of bodyCustomElementsKeys"
                                 [pageKey]="pageKey" [customElementsKey]="customElementKey" [elementLocation]="'Body'" [isNewApp]="isNewApp">
      </app-report-custom-element>
    </div>
    <div class="add-element"  [style.top]="reportPage.getLastElementYPosition()" *ngIf="enableAddElement(reportPage.paperHeight,reportPage.getLastElementYPosition()) && isNewApp">
        <button mat-icon-button [matMenuTriggerFor]="addElement">
          <mat-icon class="addIcon">add</mat-icon>
        </button>
        <mat-menu #addElement="matMenu" yPosition="below">
          <ng-content></ng-content>
        </mat-menu>
    </div>

  </section>

  <section *ngIf="reportPage.hasFooter" [ngClass]="{
      'footer': true,
      'mark-header-footer': true
    }" [style.height]="reportPage.footerHeight" (dragover)="onDragOver($event, 'Footer')"
           (drop)="onDrop($event, 'Footer')">

    <canvas *ngIf="reportPage.isDrawMode" [ngClass]="{'ghost-layer' : true}" [attr.width]="getCanvasWidth()"
            [attr.height]="getCanvasHeight('Footer')" (mousedown)="onBeginDraw($event)"
            (mouseup)="onEndDraw($event, 'Footer')"></canvas>

    <div [ngClass]="{'preview-layer' : true}">
      <app-report-text-container class="component-outer" *ngFor="let textKey of footerTextKeys" [pageKey]="pageKey"
                                 [textKey]="textKey" [elementLocation] ="'Footer'">
      </app-report-text-container>
      <app-report-line-container class="component-outer" *ngFor="let lineKey of footerLineKeys" [pageKey]="pageKey"
                                 [lineKey]="lineKey" [elementLocation] ="'Footer'">
      </app-report-line-container>
      <app-report-image-container class="component-outer" *ngFor="let imageKey of footerImageKeys" [pageKey]="pageKey"
                                  [imageKey]="imageKey" [elementLocation] ="'Footer'">
      </app-report-image-container>
      <app-report-rectangle-container class="component-outer" *ngFor="let rectangleKey of footerRectangleKeys"
                                      [pageKey]="pageKey" [rectangleKey]="rectangleKey" [elementLocation] ="'Footer'">
      </app-report-rectangle-container>
      <app-report-summary-container class="component-outer" *ngFor="let summaryKey of footerSummaryKeys"
                                    [pageKey]="pageKey" [summaryKey]="summaryKey" [elementLocation] ="'Footer'">
      </app-report-summary-container>
      <app-report-picture-container class="component-outer" *ngFor="let pictureKey of footerPictureKeys"
                                    [pageKey]="pageKey" [pictureKey]="pictureKey" [elementLocation] ="'Footer'">
      </app-report-picture-container>
      <app-report-dataplate-container class="component-outer" *ngFor="let dataPlateKey of footerDataPlateKeys"
                                      [pageKey]="pageKey" [dataPlateKey]="dataPlateKey" [elementLocation] ="'Footer'">
      </app-report-dataplate-container>
      <app-report-signature class="component-outer" *ngFor="let signatureKey of footerSignatureKeys"
                            [pageKey]="pageKey" [signatureKey]="signatureKey" [elementLocation] ="'Footer'">
      </app-report-signature>
      <app-report-table class="component-outer" *ngFor="let tableKey of footerTableKeys"
                        [pageKey]="pageKey" [tableKey]="tableKey" [elementLocation] ="'Footer'">
      </app-report-table>
    </div>

  </section>
  </div>
</div>
